<template>
    <div>
        <div id="title">
            <div class="container">
                <div class="row">
                    <!--<div class="col-md-12">-->
                        <!--<h3 class="border-bottom">-->
                            <!--<span>Интеллектуальный конфигуратор заказа</span>-->
                            <!--<a v-if="menu.length != 0" href="javascript:" @click="showAddList()" class="btn btn-outline-primary">-->
                                <!--<span v-if="!addListActive "><i class="las la-plus"></i> Добавить еще тип изделия</span>-->
                                <!--<span v-else><i class="las la-angle-up"></i> Скрыть</span>-->
                            <!--</a>-->
                        <!--</h3>-->
                    <!--</div>-->

                    <div class="col-md-12 tabs mt-2">
<!--                            <div class="col-6 active tab">-->
<!--                                <span>Интеллектуальный заказ </span>-->
<!--                                <a v-if="menu.length != 0" href="javascript:" @click="showAddList()" class="btn btn-outline-primary">-->
<!--                                    <span v-if="!addListActive " style="font-size: 14px;"><i class="las la-plus"></i> <span class="max">Добавить тип изделия</span> <span class="min">Добавить</span></span>-->
<!--                                    <span v-else><i class="las la-angle-up"></i> Скрыть</span>-->
<!--                                </a>-->
<!--                                <span class="count">{{ count.number }}</span>-->
<!--                            </div>-->
<!--                            <a href="/orderFromCatalog" class="col-6 tab">-->
<!--                                <span>Ручной заказ</span>-->
<!--                                <span class="count">{{ count.manual }}</span>-->
<!--                            </a>-->

                        <div class="row" v-if="!partner">
                            <div class="col-6 active tab">
                                <span>Интеллектуальный заказ </span>
                                <button class="btn btn-outline-primary infoButton" @click="openHowTo()"><i class="las la-info"></i></button>
                                <span class="count">{{ count.number }}</span>
                            </div>
                            <a href="/orderFromCatalog" class="col-6 tab">
                                <span>Ручной заказ</span>
                                <span class="count">{{ count.manual }}</span>
                            </a>
                        </div>
                        <div class="row" v-if="partner">
                            <div class="col-4 active tab">
                                <span>Интеллектуальный заказ </span>
                                <!--                        <button class="btn btn-outline-primary infoButton" @click="openHowTo()"><i class="las la-info"></i></button>-->
                                <span class="count">{{ count.number }}</span>
                            </div>
                            <a href="/orderFromCatalog" class="col-4 tab">
                                <span>Ручной заказ</span>
                                <span class="count">{{ count.manual }}</span>
                            </a>
                            <a href="/orderFromCatalogPartner" class="col-4 tab">
                                <span>Заказ для партнеров</span>
                                <span class="count">{{ count.manual2 }}</span>
                            </a>
                        </div>

                        <div class="col-md-12 mt-3" v-if="addListActive">
                            <carousel :navigationEnabled="true" :scrollPerPage="true" :perPageCustom="[[480, 3], [1024, 6]]" :paginationEnabled="false" :loop="true" :speed="1500">
                                <slide v-for="menuItem in menu" v-bind:key="menuItem.id">
                                    <div class="slide">
                                        <a href="javascript:" @click="addNew(menuItem.id)" class="card mb-4 shadow-sm">
    <!--                                        <div class="bd-placeholder-img card-img-top" width="100%" height="225" :style="'background-image: url(\'./img/' + menuItem.image + '\')'">-->
                                            <div class="bd-placeholder-img card-img-top" style="text-align: center; font-size: 50px; color: #bdbdbd">
                                                <!--<i v-if="!menuItem.action" class="las la-plus"></i>-->
                                                <!--&lt;!&ndash;<img v-else-if="menuItem.id_good == '20000221'" src="./../assets/img/typeAction2.jpg" />&ndash;&gt;-->
                                                <!--<img v-else src="./../assets/img/typeAction.png" />-->
                                                <!--<img v-if="menuItem.action" src="./../assets/img/actionGet.png" />-->

                                                <i v-if="!menuItem.action || noActionIDs.indexOf(Number(menuItem.id_good)) != -1" class="las la-plus"></i>
                                                <img v-else-if="actionIDs.indexOf(Number(menuItem.id_good)) != -1" src="./../assets/img/typeAction2.jpg" />
                                                <img v-else src="./../assets/img/typeAction.png" />
                                            </div>
                                            <div class="card-body">
                                                <p class="card-text">{{menuItem.folder}} {{menuItem.alt_folder}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </slide>

                                <!--<slide>-->
                                    <!--<div class="" style="margin: 0 15px;">-->
                                        <!--<a href="/orderFromCatalog" class="card mb-4 shadow-sm">-->
    <!--&lt;!&ndash;                                        <div class="bd-placeholder-img card-img-top" width="100%" height="225" :style="'background-image: url(\'/img/catalog.svg\')'"></div>&ndash;&gt;-->
                                            <!--<div class="bd-placeholder-img card-img-top" style="text-align: center; font-size: 50px; color: #bdbdbd">-->
                                                <!--<i class="las la-plus"></i>-->
                                            <!--</div>-->
                                            <!--<div class="card-body">-->
                                                <!--<p class="card-text">Ручной заказ комплектующих</p>-->
                                            <!--</div>-->
                                        <!--</a>-->
                                    <!--</div>-->
                                <!--</slide>-->
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main role="main" class="container" style="margin-top: 0px !important;">
            <div class="row">
                <div class="col-md-12">
                    <!--<div v-for="(set, index) in sets" class="set" v-bind:key="set.id">-->
                    <div v-for="(set, index) in setsNotInBusket" class="set" v-bind:key="index">
                        <div v-if="!set.inBusket" class="bigGroupHeader" v-bind:class="{ catalog: set.id == 0 }">
                            <div class="row">
                                <div class="col-8">
                                    <span v-if="set.id != 0">Рассчет комплекта для: "{{set.hh}} {{set.hh_add}}"</span>
                                    <span v-else>Ручной заказ комплектующих</span>
                                </div>
                                <div class="col-4">
                                    <button class="btn btn-light" v-on:click="toggleSet(set.id)">
                                        <i v-if="!set.minimized" class="las la-angle-up"></i>
                                        <i v-else class="las la-angle-down"></i>
                                    </button>
                                    <button class="btn btn-light" v-on:click="removeSet(set.id)"><i class="las la-trash"></i></button>
                                </div>
                            </div>
                        </div>
                        <!--<div class="info" v-if="!set.minimized && index == setExpanded">-->
                        <div class="info" v-if="!set.minimized && !set.inBusket">
                            <div class="setHeader" v-if="set.id != 0">
                                <div class="row">
                                    <div class="col-md-9">
                                        <div class="row justify-content-center">
                                            <div class="col-md-6 col-lg-7">
                                                <p>Введите необходимое количество изделий, шт:</p>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="input-group">
                                                    <span class="input-group-prepend">
                                                        <button type="button" class="btn quantity-left-minus" data-type="minus" v-on:click="changeNumber(set.id, 0, -1)">
                                                            <i class="la la-minus"></i>
                                                        </button>
                                                    </span>
                                                    <input type="text" name="quantity" class="form-control input-number" v-model="set.calcCount" @change="checkNumbers(set.id)" v-tooltip.top="{content: 'Нельзя рассчитать менее 100 изделий!', trigger: 'manual', show: set.triggerCalcCount}" maxlength="4">
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-right-plus" data-type="plus" v-on:click="changeNumber(set.id, 0, 1)">
                                                            <i class="la la-plus"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <button class="btn btn-outline-primary" type="button" v-on:click="calcCount(set.id, false)">Рассчитать</button>
                                            </div>
                                        </div>

                                        <div class="row justify-content-center" v-if="set.hide_squares.indexOf(Number(set.id_good)) == -1">
                                            <div class="col-md-6 col-lg-7">
                                                <p>Введите необходимое количество квадратных метров:</p>
                                            </div>
                                            <div class="col-md-4 col-lg-3">
                                                <div class="input-group">
                                                    <span class="input-group-prepend">
                                                        <button type="button" class="btn quantity-left-minus" data-type="minus" v-on:click="changeNumber(set.id, 1, -1)">
                                                            <i class="la la-minus"></i>
                                                        </button>
                                                    </span>
                                                    <input type="text" name="quantity" class="form-control input-number" v-model="set.squareCount" @change="checkNumbers(set.id)" v-tooltip.top="{content: 'Нельзя рассчитать менее 100 м2!', trigger: 'manual', show: set.triggerCalcSquare}" maxlength="4">
                                                    <span class="input-group-prepend">
                                                        <button class="btn quantity-right-plus" data-type="plus" v-on:click="changeNumber(set.id, 1, 1)">
                                                            <i class="la la-plus"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <button class="btn btn-outline-primary" v-on:click="calcCount(set.id, true)">Рассчитать</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 text-center">
                                        <!--Действует Акция <br><b>"ЦЕНА теперь ниже!"</b>-->
                                        <!--<img v-if="actionsArr.indexOf(set.id_good) != -1 && set.id_good == '20000221'" style="width: 85%;" src="./../assets/img/typeAction2.jpg" />-->
                                        <!--<img v-else-if="actionsArr.indexOf(set.id_good) != -1" style="width: 85%;" src="./../assets/img/typeAction.png" />-->

                                        <!--<img v-if="actionsArr.indexOf(set.id_good) != -1" src="./../assets/img/typeAction.png" />-->

                                        <img v-if="actionsArr.indexOf(set.id_good) != -1 && actionIDs.indexOf(Number(set.id_good)) != -1 && noActionIDs.indexOf(Number(set.id_good)) == -1" src="./../assets/img/typeAction2.jpg" />
                                        <img v-else-if="actionsArr.indexOf(set.id_good) != -1 && noActionIDs.indexOf(Number(set.id_good)) == -1" src="./../assets/img/typeAction.png" />

                                        <!--<img src="./../assets/img/typeAction.png" />-->
                                    </div>
                                </div>

                            </div>
                            <!--<div class="setItems" v-if="set.calculated || set.id == 0">-->
                            <div class="setItems" v-if="set.calculated">
                                <table class="table">
                                    <tr class="tableHeader">
                                        <td class="tablePhoto">Фото <br><i class="las la-angle-down"></i></td>
                                        <td class="tableName">Наименование товара <br><i class="las la-angle-down"></i></td>
                                        <td class="tableEstAmount">Расчетное кол-во <br><i class="las la-angle-down"></i></td>
                                        <td class="tableMin">Min<br>заказ <br><i class="las la-angle-down"></i></td>
                                        <td class="tableAmount">Кол-во <br><i class="las la-angle-down"></i></td>
                                        <td class="tablePriceSum">Сумма по прайсу <br><i class="las la-angle-down"></i></td>
                                        <td class="tableSaleSum">Сумма со скидкой <br><i class="las la-angle-down"></i></td>
                                        <td class="tableRemove">Удалить <br><i class="las la-angle-down"></i></td>
                                    </tr>
                                </table>

                                <table class="table" v-if="set.id == 0">
                                    <tbody>
                                    <tr>
                                        <td colspan="8">
                                            <div class="groupHeader">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <span class="subtitle">группа</span>
                                                        <span class="title">Добавлено из каталога</span>
                                                        <a href="/orderFromCatalog" class="btn btn-outline-primary"><i class="las la-plus"></i> Добавить в группу товар</a>
                                                        <button class="btn btn-outline-primary minimize" v-on:click="toggleGroup(set.id, 0)">
                                                            <i v-if="!set.groupMinimized" class="las la-angle-up"></i>
                                                            <i v-else class="las la-angle-down"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-if="!set.groupMinimized">
                                    <tr class="tableHeader">
                                        <td class="tablePhoto">Фото</td>
                                        <td class="tableName">Наименование товара</td>
                                        <td class="tableEstAmount">Расчетное кол-во</td>
                                        <td class="tableMin">Min заказ</td>
                                        <td class="tableAmount">
                                            Кол-во:
<!--                                            <br>-->
<!--                                            <span class="amounts">-->
<!--                                            <span>Выбрано:</span>-->
<!--                                            <span class="actual">16000.00</span>-->
<!--                                            <span> из </span>-->
<!--                                            <span class="from">4317</span>-->
<!--                                            <span> / осталось: </span>-->
<!--                                             <span class="left">0</span>-->
<!--                                                </span>-->
                                        </td>
                                        <td class="tablePriceSum">Сумма по прайсу</td>
                                        <td class="tableSaleSum">Сумма со скидкой</td>
                                        <td class="tableRemove">Удалить</td>
                                    </tr>
                                    </tbody>
                                    <tbody v-for="item in set.goods" v-bind:key="item.id">
                                    <tr class="item" v-if="!set.groupMinimized">
                                        <td data-label="Фото">
                                            <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + item.img +'.png'" :autoplay="true" :description="item.name">-->
                                                <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + item.img + '.png'"-->
                                                     <!--:alt="item.name" />-->
                                            <!--</silentbox-single>-->
                                            <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.img + '.png'" :autoplay="true" :description="item.name">
                                                <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.img + '.png'"
                                                     :alt="item.name" />
                                            </silentbox-single>
                                        </td>
                                        <td data-label="Наименование товара">{{item.name}}</td>
                                        <td data-label="Расчетное кол-во">{{item.cnt_per_all}}</td>
                                        <td data-label="Min заказ">{{item.package}}{{item.measure}}</td>
                                        <td data-label="Кол-во:">
                                            <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" data-type="minus" v-on:click="itemMinus(0, 0, item.id)" >
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                                <input type="text" name="quantity" class="form-control input-number" v-model="item.count" @input="updateCount(0, 0, item.id, false)" @change="updateCount(0, 0, item.id, true)">
<!--                                                <input type="text" name="quantity" readonly="" class="form-control input-number" :value="item.count">-->
                                                <span class="input-group-prepend">
                                                    <button class="btn quantity-right-plus" data-type="plus" v-on:click="itemPlus(0, 0, item.id)">
                                                        <i class="la la-plus"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                        <td data-label="Сумма по прайсу" class="sum">
                                            <div>
                                                <span class="allSum">{{item.sum}} руб.</span>
                                                <span class="pricePerOne">{{item.priceRub | fixed}} руб./{{item.measure}}</span>
                                            </div>
                                        </td>
                                        <td data-label="Сумма со скидкой" class="saleSum">
                                            <div class="totalSale" v-if="action4.indexOf(item.id) == -1">
                                                -<span>{{item.real_sale}}</span>%
                                            </div>
                                            <div v-else class="totalSale"><br/></div>
                                            <div>
                                                <span class="allSaleSum">{{item.sale_sum}} руб.</span>
                                                <span class="pricePerOne">{{item.priceRubSale | fixed}} руб./{{item.measure}}</span>
                                            </div>
                                        </td>
                                        <td data-label="Удалить">
                                            <button class="btn btn-primary remove" v-on:click="removeItem(0, 0, item.id)"><i class="las la-trash"></i></button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <table class="table group" v-for="group in set.groups" v-bind:key="group.id">
                                    <tbody>
                                    <tr>
                                        <td colspan="8">
                                            <div class="groupHeader">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <span class="subtitle">группа</span>
                                                        <span class="title" v-bind:class="{'titleWide': group.emptyBubbleData}">{{group.name}}</span>
                                                        <router-link v-if="!group.emptyBubbleData" :to="{path: '/itemsList/' + set.id + '/' + group.id}" v-bind:class="{'btn-outline-primary': (group.ids.length > 0 || (group.restAmount == 0 && group.amountAct == 0)) && group.restAmount <= 0, 'btn-danger': (group.ids.length <= 0 && group.restAmount != 0 && group.amountAct != 0) || group.restAmount > 0}" class="btn">
                                                            <i class="las la-plus"></i> Добавить в группу товар
                                                        </router-link>
                                                        <button class="btn btn-outline-primary minimize" v-on:click="toggleGroup(set.id, group.id)">
                                                            <i v-if="!group.minimized" class="las la-angle-up"></i>
                                                            <i v-else class="las la-angle-down"></i>
                                                        </button>

                                                        <span v-if="group.ids.length > 0" class="amounts" v-bind:class="{red: group.restAmount > 0}">
                                                            <span>Выбрано: </span>
                                                            <span class="actual">{{group.actualAmount}}</span>
                                                            <span> из </span>
                                                            <span class="from">{{group.amountAct}}</span>
                                                            <span> осталось: </span>
                                                            <span class="left">{{group.restAmount}}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-if="!group.minimized">
                                    <!--<tr v-if="group.items[0]" class="tableHeader">-->
                                        <!--<td class="tablePhoto">Фото</td>-->
                                        <!--<td class="tableName">Наименование товара</td>-->
                                        <!--<td class="tableEstAmount">Расчетное кол-во</td>-->
                                        <!--<td class="tableMin">Min заказ</td>-->
                                        <!--<td class="tableAmount">-->
                                            <!--Кол-во:<br>-->
                                            <!--<span class="amounts" v-bind:class="{red: group.restAmount > 0}">-->
                                                <!--<span>Выбрано: </span>-->
                                                <!--<span class="actual">{{group.actualAmount}}</span>-->
                                                <!--<span> из </span>-->
                                                <!--<span class="from">{{group.amountAct}}</span>-->
                                                <!--<span> / осталось: </span>-->
                                                <!--<span class="left">{{group.restAmount}}</span>-->
                                            <!--</span>-->
                                        <!--</td>-->
                                        <!--<td class="tablePriceSum">Сумма по прайсу</td>-->
                                        <!--<td class="tableSaleSum">Сумма со скидкой</td>-->
                                        <!--<td class="tableRemove">Удалить</td>-->
                                    <!--</tr>-->
                                    </tbody>
                                    <tbody v-if="!group.items[0] && group.restAmount != 0 && !group.minimized">
                                        <td v-if="group.emptyBubbleData && group.ids.length <= 0" colspan="7" class="text-center red">Товаров группы нет в наличии! Это не влияет на получение скидки!</td>
                                        <td v-else colspan="7" class="red text-center">Добавьте комплектующие для получения скидки!</td>
                                    </tbody>
                                    <tbody v-if="group.restAmount == 0 && group.amountAct == 0 && !group.minimized">
                                        <td v-if="group.emptyBubbleData && group.ids.length <= 0 && group.restAmount == 0 && group.amountAct == 0" class="text-center">
                                            <span class="red">Товаров группы нет в наличии! Это не влияет на получение скидки!</span><br/>
                                            <span style="color: #28a745">По нашим данным у Вас на складе еще достаточно этих комплектующих!</span>
                                        </td>
                                        <td v-else colspan="7" class="text-center" style="color: #28a745">По нашим данным у Вас на складе еще достаточно этих комплектующих!</td>
                                    </tbody>
                                    <tbody v-for="item in group.items" v-bind:key="item.id">
                                    <tr v-if="!group.minimized" class="item" v-bind:class="{'added': item.autoAdded}">
                                        <td data-label="Фото" class="noAfter tablePhoto">
                                            <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + item.img + '.png'" :autoplay="true" :description="item.name">
                                                <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.img + '.png'"
                                                     :alt="item.name" />
                                            </silentbox-single>
                                        </td>
                                        <td data-label="Наименование товара" class="tableName">
                                            <span v-bind:class="{'nameSpan': item.qualityFlag}"><span v-html="item.name"></span> <b v-if="item.autoAdded">(Добавлено)</b></span>

                                            <div class="thumb">
                                                <v-popover placement="right" :show="item.id == activeThumbID" v-if="item.qualityFlag">
                                                    <div @click="setActiveThumb(item)">
<!--                                                        <i class="las la-thumbs-up tooltip-target"></i>-->
                                                        <img src="./../assets/img/thumb.png" style="width: 34px;" alt="" class="tooltip-target" />
                                                    </div>

                                                    <template slot="popover">
                                                        <i @click="closeFlag()" v-close-popover class="closeButton las la-times-circle"></i>
                                                        <div v-html="linkContent + item.qualityFlagText"></div>
                                                        <div v-if="item.videoLink && item.videoLink.length > 10">
                                                            <button class="btn btn-outline-primary" style="color: #007bff; background: white;" @click="openVideo(item.videoLink)"><i class="las la-video"></i> Видео</button>
                                                        </div>
                                                    </template>
                                                </v-popover>
                                            </div>

                                            <!--<div v-if="item.qualityFlag" class="thumb" v-tooltip.right="{content: linkContent + item.qualityFlagText, trigger: 'click'}"><i class="las la-thumbs-up"></i></div>-->
                                        </td>
                                        <!--<td data-label="Наименование товара" class="tableName">-->
                                            <!--{{item.name}}-->
                                        <!--</td>-->
                                        <td data-label="Расчетное кол-во" class="tableEstAmount">{{item.cnt_per_all}}</td>
                                        <td data-label="Min заказ" class="noAfter tableMin">{{item.package}}{{item.measure}}</td>
                                        <td data-label="Кол-во:" class="noAfter tableAmount">
                                            <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <button type="button" class="btn quantity-left-minus" data-type="minus" v-on:click="itemMinus(set.id, group.id, item.id)">
                                                        <i class="la la-minus"></i>
                                                    </button>
                                                </span>
                                                <input v-if="item.allowEdit" type="text" name="quantity" class="form-control input-number" v-model="item.count" @input="updateCount(set.id, group.id, item.id, false)" @change="updateCount(set.id, group.id, item.id, true)">
                                                <input v-else type="text" name="quantity" readonly="" class="form-control input-number" :value="item.count">
                                                <span class="input-group-prepend">
                                                    <button class="btn quantity-right-plus" data-type="plus" v-on:click="itemPlus(set.id, group.id, item.id)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: item.clicked && (item.count + item.package) > item.gdsInStock}">
                                                        <i class="la la-plus"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                        <td data-label="Сумма по прайсу" class="sum tablePriceSum">
                                            <div>
                                                <span class="allSum">{{item.sum}} руб.</span>
                                                <span class="pricePerOne">{{item.priceRub | fixed | separate}} руб./{{item.measure}}</span>
                                            </div>
                                        </td>
                                        <td data-label="Сумма со скидкой" class="saleSum noAfter">
                                            <div class="totalSale" v-if="action4.indexOf(item.id) == -1">
                                                -<span v-if="item.boxAction">{{item.real_sale + 3}}</span><span v-else>{{item.real_sale}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.real_sale}}+3)</span>
                                            </div>
                                            <div v-else class="totalSale"><br/></div>
                                            <div>
                                                <span class="allSaleSum">{{item.sale_sum}} руб.</span>
                                                <span class="pricePerOne">{{item.priceRubSale | fixed | separate}} руб./{{item.measure}}</span>
                                            </div>
                                            <!--<img v-if="item.discount_pics_ids.indexOf(item.id) !== -1 && set.id_good == '20000221'" class="mt-1" src="./../assets/img/actionGet2.png" />-->
                                            <!--<img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                            <!--<img v-if="item.discount_pics_ids.indexOf(item.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                            <img v-if="item.discount_pics_ids.indexOf(item.id) !== -1 && action2.indexOf(item.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                            <img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1 && action3.indexOf(item.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                            <img v-else-if="item.discount_pics_ids.indexOf(item.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                        </td>
                                        <td data-label="Удалить" class="noAfter">
                                            <button class="btn btn-primary remove" v-on:click="removeItem(set.id, group.id, item.id)"><i class="las la-trash"></i></button>
                                        </td>
                                    </tr>
                                    </tbody>

                                </table>
                                    <div class="total" v-if="set.goods">
                                        <div v-if="set.goods.length > 0 && set.id != 0" class="buyMoreContainer">
                                            <h3>А не забыли ли Вы купить?:</h3>
                                            <table class="table buyMore">
                                                <tbody>
                                                <!--<tr>-->
                                                    <!--<td colspan="8"><h3>А не забыли ли Вы купить?:</h3></td>-->
                                                <!--</tr>-->
                                                <tr class="tableHeader">
                                                    <td class="tablePhoto">Фото <br><i class="las la-angle-down"></i></td>
                                                    <td class="tableName">Наименование товара <br><i class="las la-angle-down"></i></td>
                                                    <!--<td class="tableEstAmount">Расчетное кол-во</td>-->
                                                    <td class="tableMin">Min<br>заказ <br><i class="las la-angle-down"></i></td>
                                                    <td class="tableAmount text-center">Кол-во: <br><i class="las la-angle-down"></i></td>
                                                    <td class="tablePriceSum">Сумма по прайсу <br><i class="las la-angle-down"></i></td>
                                                    <td class="tableSaleSum">Сумма со скидкой <br><i class="las la-angle-down"></i></td>
                                                    <td class="tableRemove">Добавить к заказу <br><i class="las la-angle-down"></i></td>
                                                </tr>
                                                <tr v-for="(additionalItem) in set.goods" v-bind:key="additionalItem.id" class="item">
                                                    <td data-label="Фото" class="noAfter">
                                                        <!--<silentbox-single :src="'https://sale.katris.ru/img/katalog/full/' + additionalItem.img + '.png'" :autoplay="true" :description="additionalItem.name">-->
                                                            <!--<img :src="'https://sale.katris.ru/img/katalog/small/' + additionalItem.img + '.png'"-->
                                                                 <!--:alt="additionalItem.name" />-->
                                                        <!--</silentbox-single>-->
                                                        <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + additionalItem.img + '.png'" :autoplay="true" :description="additionalItem.name">
                                                            <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + additionalItem.img + '.png'"
                                                                 :alt="additionalItem.name" />
                                                        </silentbox-single>
                                                    </td>
                                                    <td data-label="Наименование товара">
                                                        <span v-bind:class="{'nameSpan': additionalItem.qualityFlag}">{{additionalItem.name}}</span>

                                                        <div class="thumb">
                                                            <v-popover placement="right" :show="additionalItem.id == activeThumbID" v-if="additionalItem.qualityFlag">
                                                                <div @click="setActiveThumb(additionalItem)">
<!--                                                                    <i class="las la-thumbs-up tooltip-target"></i>-->
                                                                    <img src="./../assets/img/thumb.png" style="width: 34px;" alt="" class="tooltip-target" />
                                                                </div>

                                                                <template slot="popover">
                                                                    <i @click="closeFlag()" v-close-popover class="closeButton las la-times-circle"></i>
                                                                    <div v-html="linkContent + additionalItem.qualityFlagText"></div>
                                                                    <div v-if="additionalItem.videoLink && additionalItem.videoLink.length > 10">
                                                                        <button class="btn btn-outline-primary" @click="openVideo(additionalItem.videoLink)"><i class="las la-video"></i> Видео</button>
                                                                    </div>
                                                                </template>
                                                            </v-popover>
                                                        </div>
                                                    </td>
                                                    <!--<td data-label="Наименование товара">-->
                                                        <!--{{additionalItem.name}}-->
                                                    <!--</td>-->
                                                    <!--<td>0</td>-->
                                                    <td data-label="Min заказ" class="noAfter">{{additionalItem.package}}{{additionalItem.measure}}</td>
                                                    <td data-label="Кол-во:" class="noAfter">
                                                        <div class="input-group">
                                                            <span class="input-group-prepend">
                                                                <button class="btn quantity-left-minus" v-on:click="additionalItemMinus(set.id, additionalItem.id)">
                                                                    <i class="la la-minus"></i>
                                                                </button>
                                                            </span>
                                                            <input type="text" name="quantity" readonly="" class="form-control input-number" :value="additionalItem.count">
                                                            <span class="input-group-prepend">
                                                                <button class="btn quantity-right-plus" v-on:click="additionalItemPlus(set.id, additionalItem.id)" v-tooltip.top="{content: 'Такого количества нет на складе!', trigger: 'manual', show: additionalItem.clicked && (additionalItem.count + additionalItem.package) > additionalItem.gdsInStock}">
                                                                    <i class="la la-plus"></i>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td data-label="Сумма по прайсу" class="sum">
                                                        <div>
                                                            <span class="allSum">{{additionalItem.sum | fixed}} руб.</span>
        <!--                                                    <span class="allSum" v-if="additionalItem.added">{{additionalItem.sum | fixed}} руб.</span>-->
        <!--                                                    <span class="allSum" v-else>0.00 руб.</span>-->
                                                            <span class="pricePerOne">{{additionalItem.priceRub | fixed}} руб./{{additionalItem.measure}}</span>
                                                        </div>
                                                    </td>
                                                    <td data-label="Сумма со скидкой" class="saleSum noAfter">
                                                        <div class="totalSale" v-if="action4.indexOf(additionalItem.id) == -1">
                                                            -<span>{{additionalItem.sale}}</span>%
                                                        </div>
                                                        <div v-else class="totalSale"><br/></div>
                                                        <div>
                                                            <span class="allSaleSum">{{additionalItem.sale_sum | fixed}} руб.</span>
        <!--                                                    <span class="allSaleSum" v-if="additionalItem.added">{{additionalItem.sale_sum | fixed}} руб.</span>-->
        <!--                                                    <span class="allSaleSum" v-else>0.00 руб.</span>-->
                                                            <span class="pricePerOne">{{additionalItem.priceRubSale | fixed}} руб./{{additionalItem.measure}}</span>
                                                        </div>
                                                        <!--<img v-if="additionalItem.discount_pics_ids.indexOf(additionalItem.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />-->
                                                        <img v-if="additionalItem.discount_pics_ids.indexOf(additionalItem.id) !== -1 && action2.indexOf(additionalItem.id) != -1" class="mt-1" src="./../assets/img/actionGet3.png" />
                                                        <img v-else-if="additionalItem.discount_pics_ids.indexOf(additionalItem.id) !== -1 && action3.indexOf(additionalItem.id) != -1" class="mt-1" src="./../assets/img/actionGet2.png" />
                                                        <img v-else-if="additionalItem.discount_pics_ids.indexOf(additionalItem.id) !== -1" class="mt-1" src="./../assets/img/actionGet.png" />
                                                    </td>
                                                    <td class="noAfter">
                                                        <button v-if="!additionalItem.added" class="btn btn-primary remove" v-on:click="additionalItemAdd(set.id, additionalItem.id)">Добавить</button>
                                                        <button v-else class="btn btn-secondary remove" v-on:click="additionalItemAdd(set.id, additionalItem.id)">Отменить</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    <div style="">
                                        <h3 v-if="set.id != 0">Расчет комплекта "{{set.folder}} {{set.alt_folder}}"</h3>
                                        <h3 v-else>Расчет комплектующих добавленных ручным способом</h3>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-md-9">
                                            <table class="table totalTable">
                                                <tbody>
                                                <tr>
                                                    <td>Сумма заказа без скидки</td>
                                                    <td></td>
                                                    <td style="width: 140px;">{{set.wholeSum | fixed | separate}} руб.</td>
                                                </tr>
                                                <tr>
                                                    <td>Ваша персональная скидка</td>
                                                    <td></td>
                                                    <td>{{set.sale}}%</td>
                                                </tr>
                                                <tr v-if="set.sale < 35 && set.next_sum > 0">
                                                    <td>Для получения скидки <span class="red">{{set.next_sale}}</span>
                                                        необходимо увеличить заказ на сумму
                                                    </td>
                                                    <td></td>
                                                    <td class="red">{{set.next_sum | fixed | separate}} руб.</td>
                                                </tr>
                                                <tr v-else-if="set.sale === 35"><td>У Вас максимальная скидка!</td><td></td><td></td></tr>
                                                <tr v-else>
                                                    <td>
                                                        <span class="red">
                                                            Для получения скидки
                                                            <span class="red">{{set.next_sale}}%</span>
                                                            необходимо заказать полный комплект
                                                        </span>
                                                    </td>
                                                    <td></td><td></td>
                                                </tr>
                                                <tr>
                                                    <td>Ваша скидка составила</td>
                                                    <td></td>
                                                    <td class="red">{{set.salesum | fixed | separate}} руб.</td>
                                                </tr>
                                                <tr class="lastTotal">
                                                    <td>Итоговая сумма заказа с персональной скидкой</td>
                                                    <td></td>
                                                    <td>{{set.saletotalsum | fixed | separate}} руб.</td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div class="row justify-content-end mt-3 p-3">
                                                <div class="col-md-6 col-lg-4">
                                                    <!--<a href="/basket" v-bind:class="{'btn-primary': binFlag, 'btn-outline-primary': !binFlag}" class="btn btn-lg btn-block"> Перейти в корзину</a>-->

                                                    <a href="#" class="btn btn-lg btn-block btn-outline-primary mb-3" style="font-size: 18px;" @click="checkBeforeBasket2(set.id)"><i class="las la-shopping-basket"></i> Добавить в корзину</a>

<!--                                                    <a href="#" class="btn btn-lg btn-block btn-outline-primary mb-3" style="font-size: 18px;" @click="addToBasket(set.id)"><i class="las la-shopping-basket"></i> Добавить в корзину</a>-->
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <button class="btn btn-outline-primary btn-lg btn-block mb-3" style="font-size: 18px;" v-on:click="toggleSet(set.id)"><i class="las la-angle-up"></i> Свернуть</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div v-if="saleFlag" class="totalEnd">
                        <!--<h3>Общая сумма заказа:</h3>-->
                        <!--<div class="row justify-content-center">-->
                            <!--<div class="col-md-9">-->
                                <!--<table class="table totalTable">-->
                                    <!--<tbody>-->
                                    <!--<tr>-->
                                        <!--<td>Сумма заказа без скидок</td>-->
                                        <!--<td>{{crm.previewsum | fixed | separate}} руб.</td>-->
                                    <!--</tr>-->
                                    <!--<tr>-->
                                        <!--<td>Ваша Экономия</td>-->
                                        <!--<td class="red">{{(crm.salesum - (crm.fullsumbasket - crm.saletotalsumbasket)) | fixed | separate}} руб.</td>-->
                                    <!--</tr>-->
                                    <!--<tr v-for="set in setsNotInBusket" v-bind:key="set.id">-->
                                        <!--<td v-if="set.calculated && set.id != 0">Комплект "{{set.hh}} {{set.hh_add}}"</td>-->
                                        <!--<td v-else-if="set.id == 0">Добавлено ручным способом</td>-->
                                        <!--<td v-if="set.calculated" class="red">{{set.sale}}%</td>-->
                                    <!--</tr>-->
                                    <!--<tr class="lastTotal">-->
                                        <!--<td>Итоговая сумма заказа с персональными скидками</td>-->
                                        <!--<td>{{(crm.saletotalsum - crm.saletotalsumbasket) | fixed | separate}} руб.</td>-->
                                    <!--</tr>-->
                                    <!--</tbody>-->
                                <!--</table>-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div class="row justify-content-center">-->
                            <!--<div class="col-lg-5">-->
                                <!--<a href="/basket" v-bind:class="{'btn-primary': binFlag, 'btn-outline-primary': !binFlag}" class="btn btn-lg btn-block"><i class="las la-shopping-basket"></i> Посмотреть все товары списком</a>-->
                            <!--</div>-->
                            <!--<div class="col-lg-4">-->
                                <!--<button v-bind:class="{'btn-primary': binFlag, 'btn-outline-primary': !binFlag}" class="btn btn-lg btn-block" @click="openOrder()">Оформить заказ</button>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="row justify-content-center mt-3">
                            <div class="col-lg-5">
                                <a href="/basket" v-bind:class="{'btn-primary': binFlag, 'btn-outline-primary': !binFlag}" class="btn btn-lg btn-block"><i class="las la-shopping-basket"></i> Перейти в корзину</a>
                            </div>
                        </div>
                    </div>
                    <div v-else class="m-5"></div>
                </div>

<!--                <nav v-if="saleFlag" class="navbar fixed-bottom navbar-expand-sm navbar-light bg-light saleInfo">-->
                <nav class="navbar fixed-bottom navbar-expand-lg navbar-light bg-light saleInfo">
                    <div class="container collapse navbar-collapse" id="navbarCollapse">
                        <div v-if="setExpanded != -1 && sets[setExpanded].calculated">
                            <span v-if="sets[setExpanded].sale < 35 && sets[setExpanded].next_sum > 0" class="navbar-text">
                                Для получения скидки
                                <span class="red">{{sets[setExpanded].next_sale}}%</span>
                                необходимо увеличить заказ на сумму:
                                <span class="red">{{sets[setExpanded].next_sum | fixed | separate}}</span> руб.
                            </span>
                            <span v-else-if="sets[setExpanded].sale === 35" class="red">У Вас максимальная скидка!</span>
                            <span v-else class="red">
                                Для получения скидки
                                <span class="red">{{sets[setExpanded].next_sale}}%</span>
                                необходимо заказать полный комплект
                            </span>
                        </div>

                        <form class="form-inline" style="margin-left: auto">
                            <button class="btn btn-outline-success my-2 my-sm-0 saleButton" type="button" @click="openPartnerProgram()">
                                <span class="big">Партнерская программа предоставления скидок</span>
                                <span class="min" style="display: none;">Партнерская программа</span>
                            </button>
                            <button class="btn btn-primary my-2 my-sm-0 saleButton" style="margin-left: 5px;" type="button" @click="openSale()"><i class="las la-shopping-cart"></i> Состояние</button>
                        </form>
                    </div>
                </nav>

                <div v-if="saleVisible" class="popoverContent">
                    <table class="table table-borderless" cellspacing="0">
                        <tbody>
                        <tr>
                            <td colspan="2" style="text-align: center; ">
                                <a href="javascript:" class="saleButton" @click="openSale()"><i class="las la-angle-down"></i> Свернуть</a>
                            </td>
                        </tr>

                        <tr v-if="count.basket + count.manual + count.manual2 > 0"><td colspan="2" class="text-center" style="font-size: 17px; padding: 0"><i class="las la-shopping-cart" style="font-size: 28px;"></i> <span style="vertical-align: 3px;">Корзина</span></td></tr>
                        <tr v-if="count.basket + count.manual + count.manual2 > 0">
                            <td>Сумма заказа без скидок</td>
                            <td>{{crm.fullsum | fixed | separate}} руб.</td>
                        </tr>
                        <tr v-if="count.basket + count.manual + count.manual2 > 0">
                            <td>Ваша Экономия</td>
                            <td class="red">{{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.</td>
                        </tr>
                        <tr v-if="count.basket + count.manual + count.manual2 > 0">
                            <td>Итоговая сумма заказа с персональными скидками</td>
                            <td class="red">{{crm.saletotalsum | fixed | separate}} руб.</td>
                        </tr>

                        <tr v-if="count.basket + count.manual + count.manual2 == 0"><td colspan="2" class="text-center" style="font-size: 20px;">Ваша корзина пуста</td></tr>

                        <tr style="border-top: 1px solid #8c8c8c">
                            <td>Сумма отгрузок за предыдущий период</td>
                            <td>{{crm.user.sum | fixed | separate}} руб.</td>
                        </tr>

                        <!--<tr>-->
                            <!--<td colspan="2" style="text-align: center">-->
                                <!--<a href="javascript:" @click="openPartnerProgram()"><i class="las la-info"></i> Партнерская программа предоставления скидок</a>-->
                            <!--</td>-->
                        <!--</tr>-->
                        </tbody>
                    </table>
                </div>

                <modal name="partner-program" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="60%"
                       height="auto">
                    <div style="padding: 20px">
                        <div id="saleRules"></div>
                        <div class="row justify-content-center">
                            <div class="col-md-4">
                                <button class="btn btn-outline-primary btn-block" @click="closePartnerProgram()">Закрыть</button>
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="order" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <p>Выберите Плательщика:</p>
                        <select v-model="orderPayerID" class="form-control">
                            <option disabled="disabled" value="-1">Не выбрано</option>
                            <option v-for="payer in payers" :value="payer.id" v-bind:key="payer.id">{{payer.name}}</option>
                        </select>
                        <br/>
                        <p>Выберите способ доставки:</p>
                        <select class="form-control" v-model="orderDeliveryID">
                            <option disabled="disabled" value="-1">Не выбрано</option>
                            <option v-for="(delivery, index) in deliveryTypes" :value="index" v-bind:key="index">{{deliveryTypes[index]}}</option>
                        </select>
                        <br/>
                        <p>Укажите свой номер заказа:</p>
                        <input class="form-control" v-model="orderNumber" type="text" maxlength="10">
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <input v-if="!orderSent" type="button" class="btn btn-primary btn-block" value="ОТПРАВИТЬ ЗАКАЗ" @click="sendOrder()" />
                                <input v-else type="button" class="btn btn-secondary btn-block" value="ОТПРАВИТЬ ЗАКАЗ" disabled />
                            </div>
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="ОТМЕНА" @click="closeOrder()" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="changes" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <h2>В заказе произошли изменения:</h2>

                        <div v-if="changes.changed[0]">
                            <p><b>Изменилась цена или скидка на следующие позиции:</b></p>

                            <div v-for="(item, index) in changes.changed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>
                        </div>

                        <div v-if="changes.removed[0]">
                            <p><b>Следующие позиции были удалены (нет в наличии):</b></p>

                            <div v-for="(item, index) in changes.removed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>

                            <p><b>Это не влияет на получение скидки</b></p>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <input type="button" class="btn btn-primary btn-block" value="Закрыть" @click="$modal.hide('changes')" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="orderFixes" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       :backdrop="false"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 style="text-transform: uppercase; color: #fb0124; padding: 10px 0; font-weight: bold; font-size: 24px;">Заказ не комплексный</h2>
                                <p style="text-align: center; font-size: 22px;">Добавьте недостающие комплектующие перед отправкой в корзину<br/> для увеличения скидки c
                                    <span style="font-size: 27px; color: blue;">{{operatingSet.sale}}%</span> до <span style="font-size: 29px; color: blue;">{{operatingSet.sale + 5}}%</span>,
                                    которая предоставляется при комплексном заказе.<br/>
                                    Позиции в общем списке, необходимые для комплесного заказа, будут подсвечены <span style="background-color: #ffffbc">желтым цветом</span></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="ДА, добавить" @click="fixSetComplex(operatingSetID, 1)" />
                            </div>
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="НЕТ, не добавлять" @click="addToBasket(operatingSetID)" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="orderFixes2" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       :backdrop="false"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>
                                    Заказ <span v-if="!properCalcFull">не</span> комплексный на ваше расчётное количество <span v-if="!properCalcMeters">изделий</span><span v-else>метров</span>.<br/>
                                    <div class="mb-3 mt-4">При этом, количество комплектующих в заказе:<br/>
                                    • {{properCalcItem.name}} = {{properCalcItem.count}} {{properCalcItem.measure}}<br/>
                                        предназначено для сборки {{properCalc}} <span v-if="!properCalcMeters">изделий</span><span v-else>метров</span>, что больше расчетного количества.<br/></div>
                                    Пересчитать заказ с {{properCalcOriginal}} на {{properCalc}} <span v-if="!properCalcMeters">изделий</span><span v-else>метров</span>?
                                </h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="ДА" @click="fixPartsCount(operatingSetID)" />
                            </div>
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="НЕТ" @click="addToBasket(operatingSetID)" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="loading" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       :backdrop="false"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>Проверка</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <img src="../assets/img/loader.gif" alt="Загрузка" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="video" :min-width="200"
                       :min-height="200"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div id="video" class="text-center">
                            <iframe width="560" height="315" :src="activeVideoLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-4">
                                <button class="btn btn-outline-primary btn-block" @click="$modal.hide('video')">Закрыть</button>
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="sale" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="60%"
                       height="auto">
                    <div style="padding: 20px">
                        <div>
                            <p><strong>Мы пролонгировали специальное предложение до 10.04.2025.</strong></p>
                            <!--                        <p>Уважаемые партнеры!</p>-->
                            <p>При размещении заказа на комплектующие, увеличена система скидок <strong>на</strong><strong style="color: rgb(230, 0, 0);"> 5%</strong><strong>-ных пункта.</strong></p>
                            <p>Обратите внимание, новая система скидок отображается при заказе у вас в личном кабинете.</p>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-4">
                                <button class="btn btn-outline-primary btn-block" @click="$modal.hide('sale')">Закрыть</button>
                            </div>
                        </div>
                    </div>
                </modal>
            </div>
        </main>
    </div>
</template>

<script>
    import ai_helper from '../js/aihelper/ai_helper';
    import series from "async-series";
    // import AI_helperItemClass from "../js/aihelper/classes/ai_helperItemClass";
    import AI_helperComplectClass from "../js/aihelper/classes/ai_helperComplectClass";
    let loaded = false;

    export default {
        props: ['id'],
        name: "Configurator",
        metaInfo: {
            title: 'Интеллектуальный конфигуратор заказа',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                sets: [],
                saleVisible: false,
                setExpanded: -1, //Какой комплект раскрыт в данный момент (ключ)
                crm: {
                    user: {
                        sum: 0
                    },
                    fullsum: 0,
                    salesum: 0,
                    saletotalsum: 0,
                    fullsumPreview: 0,
                    salesumPreview: 0,
                    saletotalsumPreview: 0
                },
                menu: [],
                menuFull: [],
                addListActive: false,
                binFlag: false,
                saleFlag: false,
                deliveryTypes: {},
                payers: [],
                orderPayerID: -1,
                orderDeliveryID: -1,
                orderNumber: '',
                orderSent: false,
                actionsArr: [],
                count: {
                    number: 0,
                    basket: 0,
                    manual: 0
                },
                // added: false
                changes: {
                    removed: [],
                    changed: []
                },
                checked: false,
                action2: [],
                // action3: [10096, 10097, 30005376, 30005377, 10095, 30005561, 10078, 30005621, 30005045, 30005056, 30004706, 30005189, 30004452, 30005265, 30005334, 30005325, 30005326, 30005187, 30004817],
                action3: [],
                actionIDs: [],
                noActionIDs: [],
                action4: [10484, 10510, 30003924, 30003926, 30003927, 30003931, 30003934, 30003937, 30003938, 30003989, 30003992, 30004055, 30004059, 30004141, 30004157, 30004163, 30004164, 30004170, 30004172, 30004173, 30004176, 30004179, 30004205, 30004232, 30004233, 30004235, 30004276, 30004277, 30004278, 30004469, 30004470, 30004471, 30004472, 30004473, 30004474, 30004515, 30004516, 30004517, 30004518, 30004526, 30004534, 30004563, 30004571, 30004575, 30004576],
                qualityFlagsArray: [],
                linkContent: 'ЗНАК КАЧЕСТВА<br/><img src="/img/itemListLogo.png" style="width: 80%; display: block; margin: 0 auto;" />',
                activeThumbID: 0,
                properCalc: 0,
                operatingSetID: 0,
                operatingSet: {},
                properCalcItem: {},
                properCalcFull: false,
                properCalcToBasket: true,
                properCalcOriginal: 0,
                properCalcMeters: false,
                allMaterials: {},
                activeVideoLink: '',
                partner: false
            }
        },
        filters: {
            fixed(value) {
                return value.toFixed(2)
            },
            separate(value) {
                let parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            }
        },
        computed: {
            setsNotInBusket() {
                let sorted = [];
                for (let key in this.sets) {
                    if (!this.sets[key].inBusket) sorted.push(this.sets[key]);
                }
                return sorted;
            }
        },
        created() {
            let self = this;

            let user = this.$session.get('user')
            if ((user.Deal == 1 && user.parent == 0) || (user.Deal == 1 && user.accDealerSale == 1)) {
                self.partner = true
            }

            let params = {
                url: 'https://sale.katris.ru/proxy/',
                // url: 'https://sale.katris.ru/proxy/AI_HELPER_45745673029734/',
                session: this.$session.get('user')
            };

            this.count = this.$countGlobal;

            // ai_helper.debug = true;
            ai_helper.init(params, function() {
                loaded = true;

                for (let i = 0; i < ai_helper.crutch.length; i++) {
                    self.actionsArr.push(Object.keys(ai_helper.crutch[i])[0])
                }

                // console.log(self.actionsArr)
            });

            // self.actionsArr.push("20000221");

            // console.log(ai_helper);

            // console.log(this.id, ai_helper.stored)

            if (this.id == undefined && ai_helper.stored == null) {
                this.$router.push({path: '/accessoriesOrdering'}).catch(e => {console.log(e)});
            } else {
                let data = {id: 0, count: 0, square: 0};

                ai_helper.makePost('aiHelper', 'get_all_materials', {}, null, function(respond) {
                    if (respond.status === 'OK') {
                        self.allMaterials = respond.data;

                        ai_helper.makePost('katrisService', 'getQualityFlags', {'token': self.$session.get('jwt')}, null, function (response) {
                            if (response.status === 'OK') {
                                self.qualityFlagsArray = response.data;

                                ai_helper.makePost('aiHelper', 'init_info', data, null, function (respond) {
                                    if (respond.status === 'OK') {
                                        respond = respond.data;

                                        self.menu = respond.complects;

                                        for (let key in self.menu) {
                                            for (let key2 in respond.crutch) {
                                                // console.log(respond.crutch[key2])
                                                // console.log(respond.crutch[key2][self.menu[key].id_good])
                                                if (Object.keys(respond.crutch[key2])[0] == self.menu[key].id_good && respond.crutch[key2][self.menu[key].id_good] == self.menu[key].parm1) {
                                                    // console.log(self.menu[key])
                                                    self.menu[key].action = true;
                                                }
                                            }

                                            if (self.menu[key].id_good == 20000221 && self.menu[key].alt_folder == 'универсал(ПАл),Слип,Тюль') {
                                                self.menu[key].alt_folder = 'универсал (ПАл), Слип, Тюль';
                                            }

                                            self.menuFull.push(self.menu[key]);

                                            // Временное решение для картинок
                                            switch (self.menu[key].folder) {
                                                case "Горизонтальные жалюзи":
                                                    self.menu[key].image = 'holis.png';
                                                    break;
                                                case "Вертикальные жалюзи":
                                                    self.menu[key].image = 'verticalplastic.png';
                                                    break;
                                                case "Горизонтальные жалюзи KS-25":
                                                    self.menu[key].image = 'ks25.png';
                                                    break;
                                                case "Рулонные шторы":
                                                    switch (self.menu[key].alt_folder) {
                                                        case "D-25":
                                                            self.menu[key].image = 'd25.png';
                                                            break;
                                                        case "линейки D-38":
                                                            self.menu[key].image = 'd38new.png';
                                                            break;
                                                        case "MINI":
                                                            self.menu[key].image = 'mini.png';
                                                            break;
                                                        case "линейки UNI":
                                                            self.menu[key].image = 'uni1.png';
                                                            break;
                                                        case "линейки CLIC":
                                                            self.menu[key].image = 'clic.png';
                                                            break;
                                                        case "Zebra Slim":
                                                            self.menu[key].image = 'zebraslim.png';
                                                            break;
                                                    }
                                                    break;
                                                case "Профильный Карниз":
                                                    switch (self.menu[key].alt_folder) {
                                                        case "I-профиль":
                                                            self.menu[key].image = 'shapedcornice.png';
                                                            break;
                                                        case "Парма,Открытая система":
                                                            self.menu[key].image = 'shapedcornice2.png';
                                                            break;
                                                        case "универсал(ПАл),Слип,Тюль":
                                                            self.menu[key].image = 'shapedcornice3.png';
                                                            break;
                                                    }
                                                    break;
                                                case "Круглый Карниз":
                                                    switch (self.menu[key].alt_folder) {
                                                        case "16":
                                                            self.menu[key].image = 'roundcornice.png';
                                                            break;
                                                        case "19":
                                                            self.menu[key].image = 'roundcornice2.png';
                                                            break;
                                                        case "25":
                                                            self.menu[key].image = 'roundcornice3.png';
                                                            break;
                                                    }
                                                    break;
                                            }
                                        }
                                    } else {
                                        console.error(respond)
                                    }

                                    // eslint-disable-next-line no-inner-declarations
                                    function check() {
                                        if (loaded) {
                                            if (ai_helper.stored !== null) {
                                                ai_helper.restoreComplects();

                                                self.restore();

                                                if (self.id != undefined) {
                                                    let compEx = 0;
                                                    for (let key in ai_helper.complects) {
                                                        if (ai_helper.complects[key].id == self.id) {
                                                            compEx = 1;
                                                        }
                                                    }
                                                    if (compEx != 1) {
                                                        self.addNew(self.id);
                                                    }
                                                    self.$router.push({path: '/configurator'});
                                                }
                                            } else if (self.id != undefined) {
                                                self.saleFlag = false;
                                                self.addNew(self.id);
                                                self.$router.push({path: '/configurator'});
                                            }

                                            ai_helper.check_complect();
                                            self.updateTotal();

                                            setTimeout(function () {
                                                self.updateTotal();
                                            }, 5000);
                                        } else {
                                            setTimeout(check, 200);
                                        }
                                    }

                                    check();

                                    let position = window.localStorage.getItem('position');
                                    if (position != null) {
                                        setTimeout(function () {
                                            window.scrollTo(0, position);
                                            window.localStorage.removeItem('position');
                                        }, 500);
                                    }
                                });
                            }
                        });
                    }
                });
            }

            // console.log(ai_helper)
        },
        mounted() {
            window.onscroll = function() {stick()};

            let navbar = document.getElementById("title");

            let sticky = navbar.offsetTop;

            function stick() {
                if (window.pageYOffset >= sticky && document.body.clientHeight > 1550) {
                    navbar.classList.add("sticky");
                } else {
                    navbar.classList.remove("sticky");
                }
            }

            // this.$modal.show('sale')
        },
        methods: {
            restore: function() {
                let self = this;

                self.sets = [];

                let changes = false;

                let counter = 0;

                for (let complect in ai_helper.complects) {

                    // for (let obj in ai_helper.complects[complect].goods) {
                    //     if (ai_helper.complects[complect].goods[obj].discount_pics_ids.indexOf(ai_helper.complects[complect].goods[obj].id) !== -1) {
                    //         console.log('123')
                    //     }
                    // }

                    counter++;
                    if (!self.checked) {
                        if (ai_helper.complects[complect].date) {
                            let today = new Date();

                            if (today - new Date(ai_helper.complects[complect].date) > 86400000) {
                            // if (today - new Date(ai_helper.complects[complect].date) > 0) {
                                if (ai_helper.complects[complect].id != 0) {
                                    let groups_request = [];
                                    if (ai_helper.complects[complect].groups[0]) {
                                        for (let key in ai_helper.complects[complect].groups) {
                                            if (Object.prototype.hasOwnProperty.call(ai_helper.complects[complect].groups, key)) {
                                                groups_request.push({
                                                    id: ai_helper.complects[complect].groups[key].id,
                                                    id_good_inet: ai_helper.complects[complect].groups[key].id_good_inet,
                                                    gids: ai_helper.complects[complect].groups[key].gids
                                                });
                                            }
                                        }
                                    }
                                    // console.log(groups_request)

                                    ai_helper.complects[complect].get_groups_bubbles(groups_request, function(data) {
                                        // console.log(data)

                                        for (let group in ai_helper.complects[complect].groups) {
                                            // console.log('test', data[ai_helper.complects[complect].groups[group].id])
                                            for (let item in ai_helper.complects[complect].groups[group].items) {
                                                let oldItem = ai_helper.complects[complect].groups[group].items[item];
                                                let newItem = data[ai_helper.complects[complect].groups[group].id][ai_helper.complects[complect].groups[group].items[item].id];

                                                // console.log(newItem.price)
                                                // console.log(oldItem.price)

                                                newItem.setName = ai_helper.complects[complect].hh + ' ' + ai_helper.complects[complect].hh_add;

                                                oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                                                oldItem.sale_exceptions = ai_helper.sale_exceptions;
                                                oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;

                                                if (!newItem.enableStock) {
                                                    self.changes.removed.push(newItem);
                                                    changes = true;
                                                    ai_helper.complects[complect].groups[group].deleteItem(oldItem);
                                                    ai_helper.complects[complect].groups[group].items.splice(item, 1);
                                                    console.log('remove');
                                                } else {
                                                    if (oldItem.price != newItem.price || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                                                        if (oldItem.price != newItem.price) {
                                                            console.log('change');
                                                            self.changes.changed.push(newItem);
                                                            changes = true;

                                                            oldItem.price = newItem.price;
                                                        }

                                                        oldItem.has_priv = newItem.has_priv;
                                                        oldItem.gdsInStock = newItem.gdsInStock;

                                                        oldItem.setDomValues();
                                                    } else {
                                                        console.log('no changes');
                                                    }
                                                }
                                            }
                                        }

                                        if (counter == ai_helper.complects.length) {
                                            if (changes) self.$modal.show('changes');
                                            ai_helper.check_complect();
                                            self.checked = true;
                                            ai_helper.complects[complect].date = new Date();
                                        }

                                    });
                                } else {
                                    ai_helper.makePost('aiHelper', 'get_common_bubble', {}, null, function(respond) {
                                        if (respond.status === 'OK') {
                                            // console.log(respond.data.items)
                                            for (let item in ai_helper.complects[complect].goods) {
                                                let oldItem = ai_helper.complects[complect].goods[item];
                                                let newItem = respond.data.items[ai_helper.complects[complect].goods[item].id];

                                                newItem.setName = 'Ручной заказ';

                                                oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                                                oldItem.sale_exceptions = ai_helper.sale_exceptions;
                                                oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;

                                                // console.log('test', oldItem, newItem);

                                                if (!newItem.enableStock) {
                                                    self.changes.removed.push(newItem);
                                                    changes = true;
                                                    ai_helper.complects[complect].goods.splice(item, 1);
                                                    console.log('remove');
                                                } else {
                                                    if (oldItem.price != newItem.price || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                                                        if (oldItem.price != newItem.price) {
                                                            console.log('change');
                                                            self.changes.changed.push(newItem);
                                                            changes = true;

                                                            oldItem.price = newItem.price;
                                                        }

                                                        oldItem.has_priv = newItem.has_priv;
                                                        oldItem.gdsInStock = newItem.gdsInStock;

                                                        oldItem.setDomValues();
                                                    } else {
                                                        console.log('no changes');
                                                    }
                                                }
                                            }
                                        }

                                        if (counter == ai_helper.complects.length) {
                                            if (changes) self.$modal.show('changes');
                                            ai_helper.check_complect();
                                            self.checked = true;
                                            ai_helper.complects[complect].date = new Date();
                                        }
                                    });
                                }
                            }
                        } else {
                            ai_helper.complects[complect].date = new Date();
                        }
                    }

                    if (counter == ai_helper.complects.length) {
                        if (changes) self.$modal.show('changes');
                        ai_helper.check_complect();
                        self.checked = true;
                        ai_helper.complects[complect].date = new Date();
                    }

                    let groups = [];
                    // console.log('calc', ai_helper.complects[complect].calculated)
                    if (ai_helper.complects[complect].calculated == true) {
                        self.binFlag = true;
                        self.saleFlag = true;
                    }

                    for (let key in ai_helper.complects[complect].groups) {
                        let items = [];
                        for (let item in ai_helper.complects[complect].groups[key].items) {
                            if (!ai_helper.complects[complect].inBusket) {
                                self.saleFlag = true;
                            }
                            ai_helper.complects[complect].groups[key].items[item].clicked = false;

                            // if (ai_helper.complects[complect].id_good == '20000131' && ai_helper.complects[complect].groups[key].id == '8460' && [8696, 8693, 8694].indexOf(ai_helper.complects[complect].groups[key].items[item].id) == -1) {
                                ai_helper.complects[complect].groups[key].items[item].allowEdit = true;
                            // } else {
                            //     ai_helper.complects[complect].groups[key].items[item].allowEdit = false;
                            // }

                            ai_helper.complects[complect].groups[key].items[item].qualityFlag = false;
                            ai_helper.complects[complect].groups[key].items[item].qualityFlagText = '';
                            ai_helper.complects[complect].groups[key].items[item].videoLink = '';

                            for (let flag in self.qualityFlagsArray) {
                                if (self.qualityFlagsArray[flag].goodID == ai_helper.complects[complect].groups[key].items[item].id && self.qualityFlagsArray[flag].active == 1) {
                                    ai_helper.complects[complect].groups[key].items[item].qualityFlag = true;
                                    ai_helper.complects[complect].groups[key].items[item].qualityFlagText = self.qualityFlagsArray[flag].text;
                                    ai_helper.complects[complect].groups[key].items[item].videoLink = self.qualityFlagsArray[flag].videoLink;
                                }
                            }

                            items.push(ai_helper.complects[complect].groups[key].items[item]);
                        }
                        ai_helper.complects[complect].groups[key].items = items;
                        groups.push(ai_helper.complects[complect].groups[key]);
                    }

                    let goods = [];
                    for (let key in ai_helper.complects[complect].goods) {
                        ai_helper.complects[complect].goods[key].clicked = false;
                        ai_helper.complects[complect].goods[key].qualityFlag = false;
                        ai_helper.complects[complect].goods[key].qualityFlagText = '';
                        ai_helper.complects[complect].goods[key].videoLink = '';

                        if (ai_helper.complects[complect].id != 0 && ai_helper.complects[complect].goods[key].count == 0) {
                            ai_helper.complects[complect].goods[key].count = ai_helper.complects[complect].goods[key].package;
                        }

                        for (let flag in self.qualityFlagsArray) {
                            if (self.qualityFlagsArray[flag].goodID == ai_helper.complects[complect].goods[key].id && self.qualityFlagsArray[flag].active == 1) {
                                ai_helper.complects[complect].goods[key].qualityFlag = true;
                                ai_helper.complects[complect].goods[key].qualityFlagText = self.qualityFlagsArray[flag].text;
                                ai_helper.complects[complect].goods[key].videoLink = self.qualityFlagsArray[flag].videoLink;
                            }
                        }

                        ai_helper.complects[complect].goods[key].setDomValues();
                        goods.push(ai_helper.complects[complect].goods[key]);
                    }

                    ai_helper.complects[complect].groups = groups;

                    goods.sort(function action(a, b) {
                        if (b.discount_pics_ids.indexOf(b.id) == -1)
                            return -1;
                        if (b.discount_pics_ids.indexOf(b.id) !== -1)
                            return 1;
                        return 0;
                    });

                    ai_helper.complects[complect].goods = goods;
                    ai_helper.complects[complect].goodsVisible = goods;

                    ai_helper.complects[complect].parm1 = ai_helper.complects[complect].hh_add;
                    ai_helper.complects[complect].folder = ai_helper.complects[complect].hh;
                    ai_helper.complects[complect].alt_folder = ai_helper.complects[complect].hh_add;

                    ai_helper.complects[complect].triggerCalcCount = false;
                    ai_helper.complects[complect].triggerCalcSquare = false;

                    ai_helper.complects[complect].get_basket_sum();

                    self.sets.push(ai_helper.complects[complect]);

                    for (let key in self.menu) {
                        if (self.sets.find(set => set.id == self.menu[key].id) != undefined) {
                            self.menu.splice(key, 1);
                        }
                    }
                }

                // if (changes) alert('Коррекция');

                // setTimeout(function() {
                //     console.log(changes)
                //     console.log(self.changes)
                //     if (changes) self.$modal.show('changes');
                // }, 3500);

                // let common = false;
                for (let set in self.sets) {
                    // if (self.sets[set].id == 0) common = true
                    // console.log('min', self.sets[set].minimized)
                    // if (self.sets[set].minimized === false && self.sets[set].calculated === true) {
                    if (self.sets[set].minimized === false && !self.sets[set].inBusket && self.sets[set].id != 0) {
                        self.setExpanded = set;
                    }

                    for (let group in self.sets[set].groups) {
                        self.sets[set].groups[group].getActualAmount(function () {});
                    }
                }

                let allInBusket = true;
                for (let set in self.sets) {
                    // console.log('set', set)
                    if (!self.sets[set].inBusket) allInBusket = false;
                    // console.log(set.inBusket)
                }
                // console.log('allInBusket', allInBusket)
                if (allInBusket) {
                    self.$router.push({path: '/accessoriesOrdering'}).catch(e => {console.log(e)});
                }

                if (this.prevRoute.path == '/' && document.referrer.indexOf('/orderFromCatalog') != -1 && self.sets[self.sets.length - 1].id == 0) {
                    for (let set in self.sets) {
                        if (self.sets[set]['id'] != 0) {
                            self.sets[set].minimized = true;
                        } else {
                            self.sets[set].minimized = false;
                            self.setExpanded = set;
                        }
                    }
                }
            },
            calcCount: function(id, isSquare) {
                let self = this;
                self.binFlag = true;

                let calcCount = 0, squareCount = 0;

                for (let key in self.sets) {
                    if (self.sets[key].id == id) {
                        calcCount = self.sets[key].calcCount;
                        squareCount = self.sets[key].squareCount;
                    }
                }

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key].id == id) {
                        ai_helper.complects[key].check1 = false;
                        ai_helper.complects[key].check2 = false;
                        ai_helper.complects[key].parts(id, calcCount, squareCount, isSquare, function() {
                            self.sets = [];
                            self.restore();

                            self.updateTotal();
                        });
                    }
                }

                this.$countGlobal.number = 0;
                this.$countGlobal.basket = 0;
                this.$countGlobal.manual2 = 0;

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key] != 'empty') {
                        if (ai_helper.complects[key] && ai_helper.complects[key].id != 0) {
                            if (ai_helper.complects[key].inBusket)
                                this.$countGlobal.basket++;
                            else
                                this.$countGlobal.number++;
                        } else {
                            for (let good in ai_helper.complects[key].goods) {
                                if (ai_helper.complects[key].goods[good].partner) {
                                    this.$countGlobal.manual2++
                                }
                            }

                            this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length - this.$countGlobal.manual2;
                        }
                    }
                }

                this.count = this.$countGlobal;
            },
            removeSet: function(id) {
                let self = this;
                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key].id == id) {
                        delete ai_helper.complects[key];
                        // ai_helper.complects.splice(key, 1);
                    }
                }

                self.setExpanded = -1;

                // console.log('ln', self.menu.length)

                for (let key in self.menuFull) {
                    // console.log(self.menu[key].id)
                    // console.log(key)
                    // console.log('k', self.menuFull[key].id)

                    if (self.menu[key] && self.menu[key].id != self.menuFull[key].id) {
                        // console.log('ln2', self.menu.length)
                        self.menu.splice(key, 0, self.menuFull[key]);
                    }
                }

                setTimeout(function() {
                    for (let key in self.sets) {
                        if (self.sets[key].id == id) {
                            self.sets.splice(key, 1);
                        }

                        if (self.sets.length <= 0) {
                            self.$router.push({path: '/accessoriesOrdering'}).catch(e => {console.log(e)});
                        }
                    }

                    for (let key in self.menu) {
                        if (self.sets.find(set => set.id == self.menu[key].id) != undefined) {
                            self.menu.splice(key, 1);
                        }
                    }
                }, ai_helper.inputTimer + 500);

                ai_helper.check_complect();
                ai_helper.storeComplects();

                this.$countGlobal.number = 0;
                this.$countGlobal.basket = 0;

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key] != 'empty') {
                        // console.log(ai_helper.complects[key].inBusket)
                        if (ai_helper.complects[key].id != 0) {
                            if (ai_helper.complects[key].inBusket)
                                this.$countGlobal.basket++;
                            else
                                this.$countGlobal.number++;
                        } else {
                            this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length;
                        }
                    }
                }

                this.count = this.$countGlobal;

                self.updateTotal();

                let allInBusket = true;
                for (let set in ai_helper.complects) {
                    if (!ai_helper.complects[set].inBusket) allInBusket = false;
                }
                if (allInBusket) self.$router.push({path: '/accessoriesOrdering'}).catch(e => {console.log(e)});
            },
            toggleSet: function(id) {
                let self = this;
                for (let key in self.sets) {
                    if (self.sets[key].id == id) {
                        console.log(self.sets[key])
                        self.sets[key].minimized = !self.sets[key].minimized;
                        if (self.sets[key].minimized != true) {
                            self.setExpanded = key;
                        } else {
                            self.setExpanded = -1;
                        }
                    } else {
                        self.sets[key].minimized = true;
                    }
                }
                ai_helper.storeComplects();
            },
            toggleGroup: function(setId, groupId) {
                let self = this;
                if (setId != 0) {
                    for (let key in self.sets) {
                        if (self.sets[key].id == setId) {
                            for (let group in self.sets[key].groups) {
                                if (self.sets[key].groups[group].id == groupId) {
                                    console.log(self.sets[key].groups[group])
                                    self.sets[key].groups[group].minimized = !self.sets[key].groups[group].minimized;
                                }
                            }
                        }
                    }
                } else {
                    for (let key in self.sets) {
                        if (self.sets[key].id == setId) {
                            self.sets[key].groupMinimized = !self.sets[key].groupMinimized;
                        }
                    }
                }
                ai_helper.storeComplects();
            },
            removeItem: function(setId, groupId, itemId) {
                let self = this;
                let set = self.sets.find(complect => complect.id == setId);
                set.check1 = false;
                set.check2 = false;
                if (setId != 0) {
                    for (let group in set.groups) {
                        if (set.groups[group].id == groupId) {
                            let item = set.groups[group].items.find(item => item.id == itemId);
                            for (let item in set.groups[group].items) {
                                if (set.groups[group].items[item].id == itemId) {
                                    set.groups[group].items.splice(item, 1);
                                }
                            }
                            set.groups[group].deleteItem(item);
                        }
                    }
                } else {
                    for (let item in set.goods) {
                        if (set.goods[item].id == itemId) {
                            // delete set.goods[item];

                            set.goods.splice(item, 1);
                        }
                    }
                }
                ai_helper.check_complect();
                self.updateTotal();
            },
            itemPlus: function(setId, groupId, itemId) {
                let self = this;
                let item;
                let set = self.sets.find(complect => complect.id == setId);
                set.check1 = false;
                set.check2 = false;
                if (setId != 0) {
                    item = set.groups.find(group => group.id == groupId).items.find(item => item.id == itemId);
                } else {
                    for (let item2 in set.goods) {
                        if (set.goods[item2].id == itemId) {
                            item = set.goods[item2];
                        }
                    }
                }

                if (item.count + item.package <= item.gdsInStock) {
                    item.count += item.package;
                    item.setDomValues();
                    set.get_basket_sum();
                    if (setId != 0) {
                        set.groups.find(group => group.id == groupId).event();
                        self.sets.find(complect => complect.id == setId).groups.find(group => group.id == groupId).getActualAmount();
                    }
                    ai_helper.check_complect();

                } else {
                    item.clicked = true;
                    setTimeout(function() {
                        item.clicked = false;
                    }, 2500);
                }
                self.updateTotal();
            },
            itemMinus: function(setId, groupId, itemId) {
                let self = this;
                let item;
                let set = self.sets.find(complect => complect.id == setId);
                set.check1 = false;
                set.check2 = false;
                if (setId != 0) {
                    item = set.groups.find(group => group.id == groupId).items.find(item => item.id == itemId);
                } else {
                    for (let item2 in set.goods) {
                        if (set.goods[item2].id == itemId) {
                            item = set.goods[item2];
                        }
                    }
                }

                if (item.count > 0 && (item.count - item.package) >= 0) {
                    item.count -= item.package;
                    item.setDomValues();
                    set.get_basket_sum();
                    if (setId != 0) {
                        set.groups.find(group => group.id == groupId).event();
                        self.sets.find(complect => complect.id == setId).groups.find(group => group.id == groupId).getActualAmount();
                    }
                    ai_helper.check_complect();

                } else if ((item.count - item.package) < 0) {
                    self.removeItem(setId, groupId, itemId);
                }
                self.updateTotal();
            },
            updateCount: function(setId, groupId, itemId, fix) {
                let self = this;
                let set = self.sets.find(complect => complect.id == setId);
                set.check1 = false;
                set.check2 = false;
                let item, group;
                if (setId != 0) {
                    group = set.groups.find(group => group.id == groupId);
                    item = group.items.find(item => item.id == itemId);
                } else {
                    group = false;
                    item = set.goods.find(good => good.id = itemId);
                }

                if (item.count > item.gdsInStock && fix) {
                    item.count = item.gdsInStock;

                    item.clicked = true;
                    setTimeout(function() {
                        item.clicked = false;
                    }, 2500);
                } else if (item.count < item.package && fix) {
                    item.count = item.package;
                }

                if (!(group && set.id_good == '20000131' && group.id == '8460' && [8696, 8693, 8694].indexOf(item.id) == -1)) {
                    if (fix) {
                        // console.log(item.count, Math.floor(item.count / item.package), item.package)
                        item.count = Math.floor(item.count / item.package) * item.package;
                    }
                }

                item.setDomValues();
                set.get_basket_sum();

                if (setId != 0) {
                    group.event();
                    group.getActualAmount();
                }

                self.updateTotal();

                // this.items[item].sum = this.items[item].count * this.items[item].priceRub;
                // this.items[item].sale_sum = this.items[item].count * this.items[item].priceRubSale;
            },
            additionalItemAdd: function(setId, itemId) {
                let self = this;
                for (let key in self.sets) {
                    if (self.sets[key].id == setId) {
                        for (let item in self.sets[key].goods) {
                            if (self.sets[key].goods[item].id == itemId) {
                                self.sets[key].goods[item].added = !self.sets[key].goods[item].added;

                                if (self.sets[key].goods[item].count == 0 && self.sets[key].goods[item].added) {
                                    self.sets[key].goods[item].count = self.sets[key].goods[item].package;
                                    self.sets[key].goods[item].setDomValues();
                                    self.sets[key].get_basket_sum();
                                }

                                ai_helper.check_complect();
                            }
                        }
                    }
                }
                self.updateTotal();
            },
            additionalItemPlus: function(setId, itemId) {
                let self = this;
                for (let key in self.sets) {
                    if (self.sets[key].id == setId) {
                        for (let item in self.sets[key].goods) {
                            if (self.sets[key].goods[item].id == itemId) {
                                if (self.sets[key].goods[item].count + self.sets[key].goods[item].package <= self.sets[key].goods[item].gdsInStock) {
                                    self.sets[key].goods[item].count += self.sets[key].goods[item].package;
                                    self.sets[key].goods[item].setDomValues();
                                    self.sets[key].get_basket_sum();
                                    ai_helper.check_complect();
                                } else {
                                    self.sets[key].goods[item].clicked = true;
                                    setTimeout(function() {
                                        self.sets[key].goods[item].clicked = false;
                                    }, 2500);
                                }
                            }
                        }
                    }
                }
                self.updateTotal();
            },
            additionalItemMinus: function(setId, itemId) {
                let self = this;
                for (let key in self.sets) {
                    if (self.sets[key].id == setId) {
                        for (let item in self.sets[key].goods) {
                            if (self.sets[key].goods[item].id == itemId) {
                                if (self.sets[key].goods[item].added && (self.sets[key].goods[item].count - self.sets[key].goods[item].package) >= self.sets[key].goods[item].package || !self.sets[key].goods[item].added && (self.sets[key].goods[item].count - self.sets[key].goods[item].package) >= 0) {
                                    self.sets[key].goods[item].count -= self.sets[key].goods[item].package;
                                    self.sets[key].goods[item].setDomValues();
                                    self.sets[key].get_basket_sum();
                                    ai_helper.check_complect();
                                } else if (self.sets[key].goods[item].added) {
                                    self.additionalItemAdd(setId, itemId);
                                    self.sets[key].goods[item].count = 0;
                                }
                            }
                        }
                    }
                }
                self.updateTotal();
            },
            openSale: function() {
                this.saleVisible = !this.saleVisible;
            },
            openPartnerProgram: function() {
                ai_helper.makePost('aiHelper', 'sales', {}, null,function(respond) {
                    if (respond.status === 'OK') {
                        document.getElementById('saleRules').innerHTML = respond.data;

                        document.querySelector('#saleRules table').classList.add("table");
                    }
                });

                this.$modal.show('partner-program')
            },
            closePartnerProgram: function() {
                this.$modal.hide('partner-program')
            },
            openOrder: function() {
                let self = this;
                ai_helper.getOrderItems(function(data) {
                    // console.log(data)
                    let er = '';
                    if (data.order.length <= 0) er += 'Заказ не содержит ни одной позиции! \n';
                    if (ai_helper.fullsum <= 0) er += 'Вы не можете отправить пустой заказ! \n';
                    if (!er) {
                        ai_helper.makePost('aiHelper', 'payersList', {}, null, function(respond) {
                            if (respond.status === 'OK') {
                                self.payers = [];
                                for (let key in respond.data.payers) {
                                    self.payers.push({id: key, name: respond.data.payers[key].showName});
                                }
                            }
                        });
                        self.deliveryTypes = ai_helper.deliveryTypes;
                        self.$modal.show('order');
                    } else
                        alert(er);
                });
            },
            closeOrder: function() {
                this.$modal.hide('order')
            },
            sendOrder: function() {
                if (this.orderNumber != '' && this.orderDeliveryID != -1 && this.orderPayerID != -1) {
                    this.orderSent = true;

                    ai_helper.num = this.orderNumber;
                    ai_helper.delivery = this.orderDeliveryID;
                    ai_helper.payer = this.orderPayerID;
                    ai_helper.prepareComplectOrder();
                } else {
                    alert('Не все поля корректно заполнены!');
                }
            },
            showAddList: function() {
                this.addListActive = !this.addListActive;
            },
            addNew: function(id) {
                let setObj = 0;
                let self = this;

                if (self.sets.find(item => item != undefined && item.id == id) == undefined) {
                    self.addListActive = false;

                    let data = {id: 0, count: 0, square: 0};
                    ai_helper.makePost('aiHelper', 'init_info', data, null, function(respond) {
                        for (let key in respond.data.complects) {
                            if (respond.data.complects[key].id == id) {
                                setObj = respond.data.complects[key];
                            }
                        }
                        if (setObj == 0) {
                            self.$router.push({path: '/accessoriesOrdering'});
                        } else {
                            ai_helper.add_complect(setObj);

                            let item = ai_helper.complects.find(item => item != undefined && item.id == id);

                            item.minimized = false;
                            item.calcCount = 100;
                            item.squareCount = 100;

                            for (let key in self.sets) {
                                self.sets[key].minimized = true;
                            }

                            self.sets.push(item);

                            self.setExpanded = self.sets.length - 1;
                            self.updateTotal();

                            for (let key in self.menu) {
                                if (self.sets.find(set => set.id == self.menu[key].id) != undefined) {
                                    self.menu.splice(key, 1);
                                }
                            }
                        }
                    });
                }
            },
            checkNumbers: function(setId) {
                let self = this;
                let set = self.sets.find(complect => complect.id == setId);
                set.squareCount = Number(parseFloat(set.squareCount));
                set.calcCount = Number(parseFloat(set.calcCount));
                if (isNaN(set.squareCount)) set.squareCount = 0;
                if (isNaN(set.calcCount)) set.calcCount = 0;

                if (set.squareCount < 100) {
                    set.squareCount = 100;
                    set.triggerCalcSquare = true;
                    setTimeout(function() {
                        set.triggerCalcSquare = false;
                    }, 2500);
                }

                if (set.calcCount < 100) {
                    set.calcCount = 100;
                    set.triggerCalcCount = true;
                    setTimeout(function() {
                        set.triggerCalcCount = false;
                    }, 2500);
                }
            },
            changeNumber(setId, countOrSquare, plusOrMinus) {
                let self = this;
                let set = self.sets.find(complect => complect.id == setId);
                set.check1 = false;
                set.check2 = false;
                if (countOrSquare == 1) set.squareCount = set.squareCount + plusOrMinus;
                if (countOrSquare == 0) set.calcCount = set.calcCount + plusOrMinus;
                self.checkNumbers(setId);
            },
            updateTotal: function() {
                this.crm.user.sum = ai_helper.user.sum;
                this.crm.fullsum = ai_helper.fullsum;
                this.crm.fullsumbasket = ai_helper.fullsumbasket;
                this.crm.salesum = ai_helper.salesum;
                this.crm.saletotalsum = ai_helper.saletotalsum;
                this.crm.saletotalsumbasket = ai_helper.saletotalsumbasket;
                this.crm.previewsum = ai_helper.previewsum;
            },
            checkBeforeBasket: function(setId) {
                let self = this;

                let set = self.sets.find(complect => complect.id == setId);

                self.properCalcToBasket = true;
                self.operatingSetID = setId;
                self.operatingSet = set;
                console.log(set)

                let manualSet = self.sets.find(complect => complect.id == 0);

                if (!manualSet) {
                    if (set.full || set.check1) {
                        self.properCalcFull = true;
                        // self.checkBeforeBasket2(setId);
                        self.addToBasket(setId);
                    } else {
                        set.check1 = true;
                        self.$modal.show('orderFixes')
                    }
                } else {
                    self.addToBasket(setId)
                }
            },
            checkBeforeBasket2: function(setId) {
                let self = this;

                self.operatingSetID = setId;

                let set = self.sets.find(complect => complect.id == setId);

                let manualSet = self.sets.find(complect => complect.id == 0);

                //console.log(set)

                if (!set.check2 && !manualSet && set.id_good != "30003607" && set.id_good != "20000221") {
                    self.$modal.hide('orderFixes');
                    self.$modal.show('loading');

                    set.check2 = true;
                    let ok = true;

                    let calcCount = 0;
                    self.properCalc = 0;
                    self.properCalcOriginal = set.calcCount;
                    if (set.square) {
                        self.properCalcMeters = true;
                        self.properCalcOriginal = set.squareCount;
                    }

                    let i = 0;

                    // eslint-disable-next-line no-inner-declarations
                    function checkGroup() {
                        if (set.groups[i].items[0]) {
                            // let ids = '';
                            //
                            // for (let id in set.groups[i].ids) {
                            //     if (id != 0) ids += ', ';
                            //     ids += set.groups[i].ids[id];
                            // }

                            let i2 = 0;

                            // eslint-disable-next-line no-inner-declarations
                            function checkItem() {
                                series([
                                    function (done) {
                                        for (let item in set.infoArray) {
                                            if (set.infoArray[item].id_good_ref == set.groups[i].items[i2].id && set.infoArray[item].id_good_inet == set.groups[i].id_good_inet) {
                                                set.groups[i].items[i2].setInfo = set.infoArray[item];
                                            }
                                        }

                                        //console.log(set.groups[i].items[i2].setInfo)

                                        if (set.groups[i].items[i2].setInfo) {
                                            if (set.groups[i].items[i2].setInfo.set == false) {
                                                let material;

                                                if (self.allMaterials[set.groups[i].items[i2].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[set.groups[i].items[i2].id]) == -1) {
                                                    material = self.allMaterials[set.groups[i].items[i2].id];

                                                    let partData = {set: false};

                                                    switch (material.ptype) {
                                                        case 'rolo':
                                                            partData = {
                                                                set: {
                                                                    id_good: "20000163",
                                                                    id_good_inet: "222",
                                                                    parm1: "D-25"
                                                                }
                                                            };
                                                            break;
                                                        case 'vblinds':
                                                            partData = {
                                                                set: {
                                                                    id_good: "20000131",
                                                                    id_good_inet: "11",
                                                                    parm1: "классик"
                                                                }
                                                            };
                                                            break;
                                                        case 'ks25':
                                                            partData = {
                                                                set: {
                                                                    id_good: "30003858",
                                                                    id_good_inet: "69",
                                                                    parm1: ""
                                                                }
                                                            };
                                                            break;
                                                        case 'karniz':
                                                            break;
                                                        case 'plisse':
                                                            partData = {
                                                                set: {
                                                                    id_good: "30005223",
                                                                    id_good_inet: "514",
                                                                    parm1: ""
                                                                }
                                                            };
                                                            break;
                                                        case 'roma':
                                                            break;
                                                        case 'zebra':
                                                            partData = {
                                                                set: {
                                                                    id_good: "20000163",
                                                                    id_good_inet: "228",
                                                                    parm1: "Zebra Slim"
                                                                }
                                                            };
                                                            break;
                                                        case 'catalog':
                                                            break;
                                                        case 'access':
                                                            break;
                                                    }

                                                    set.groups[i].items[i2].setInfo.set = partData.set;

                                                    done();
                                                }
                                            } else {
                                                done();
                                            }
                                        } else {
                                            i2++;
                                            if (i2 < set.groups[i].items.length) {
                                                checkItem();
                                            } else {
                                                i++;
                                                if (i < set.groups.length) {
                                                    checkGroup();
                                                } else {
                                                    if (ok) {
                                                        self.$modal.hide('loading');
                                                        // self.addToBasket(setId);
                                                        self.checkBeforeBasket(setId);
                                                    } else {
                                                        self.$modal.hide('loading');
                                                        self.$modal.show('orderFixes2')
                                                    }
                                                }
                                            }
                                        }

                                        // ai_helper.makePost('katrisService', 'getGoodAIHelperInfo', {id: set.groups[i].items[i2].id}, null, function (respond) {
                                        //     if (respond.status === 'OK') {
                                        //         set.groups[i].items[i2].setInfo = respond.data;
                                        //
                                        //         if (set.groups[i].items[i2].setInfo.set == false) {
                                        //             let material;
                                        //             if (self.allMaterials[set.groups[i].items[i2].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[set.groups[i].items[i2].id]) == -1) {
                                        //                 material = self.allMaterials[set.groups[i].items[i2].id];
                                        //
                                        //                 let partData = {set: false};
                                        //
                                        //                 switch (material.ptype) {
                                        //                     case 'rolo':
                                        //                         partData = {
                                        //                             set: {
                                        //                                 id_good: "20000163",
                                        //                                 id_good_inet: "222",
                                        //                                 parm1: "D-25"
                                        //                             }
                                        //                         };
                                        //                         break;
                                        //                     case 'vblinds':
                                        //                         partData = {
                                        //                             set: {
                                        //                                 id_good: "20000131",
                                        //                                 id_good_inet: "11",
                                        //                                 parm1: "классик"
                                        //                             }
                                        //                         };
                                        //                         break;
                                        //                     case 'ks25':
                                        //                         partData = {
                                        //                             set: {
                                        //                                 id_good: "30003858",
                                        //                                 id_good_inet: "69",
                                        //                                 parm1: ""
                                        //                             }
                                        //                         };
                                        //                         break;
                                        //                     case 'karniz':
                                        //                         break;
                                        //                     case 'plisse':
                                        //                         partData = {
                                        //                             set: {
                                        //                                 id_good: "30005223",
                                        //                                 id_good_inet: "514",
                                        //                                 parm1: ""
                                        //                             }
                                        //                         };
                                        //                         break;
                                        //                     case 'roma':
                                        //                         break;
                                        //                     case 'zebra':
                                        //                         partData = {
                                        //                             set: {
                                        //                                 id_good: "20000163",
                                        //                                 id_good_inet: "228",
                                        //                                 parm1: "Zebra Slim"
                                        //                             }
                                        //                         };
                                        //                         break;
                                        //                     case 'catalog':
                                        //                         break;
                                        //                     case 'access':
                                        //                         break;
                                        //                 }
                                        //
                                        //                 set.groups[i].items[i2].setInfo = partData;
                                        //             }
                                        //         }
                                        //
                                        //         done();
                                        //     }
                                        // })
                                    },
                                    function (done) {
                                        if (!set.groups[i].items[i2].setInfo.details) {
                                            ai_helper.makePost('katrisService', 'getGoodsDetails', {
                                                'token': self.$session.get('jwt'),
                                                goodID: set.groups[i].items[i2].setInfo.set.id_good,
                                                param: set.groups[i].items[i2].setInfo.set.parm1,
                                                idInet: set.groups[i].items[i2].setInfo.set.id_good_inet
                                            }, null, function (respond) {

                                                if (respond.status === 'OK') {
                                                    // console.log(respond.data)
                                                    set.groups[i].items[i2].goodDetails = respond.data;
                                                    done();
                                                }
                                            });
                                        } else {
                                            set.groups[i].items[i2].goodDetails = set.groups[i].items[i2].setInfo.details;
                                            done();
                                        }
                                    },
                                    function (done) {
                                        if (!set.groups[i].items[i2].setInfo.dictionary) {
                                            ai_helper.makePost('katrisService', 'getGoodsDictionary', {
                                                'token': self.$session.get('jwt'),
                                                groupID: set.groups[i].items[i2].setInfo.set.id_good,
                                                param: set.groups[i].items[i2].setInfo.set.parm1,
                                                idInet: set.groups[i].items[i2].setInfo.set.id_good_inet
                                            }, null, function (respond) {
                                                if (respond.status === 'OK') {
                                                    set.groups[i].items[i2].goodDictionary = respond.data;
                                                    done()
                                                }
                                            });
                                        } else {
                                            set.groups[i].items[i2].goodDictionary = set.groups[i].items[i2].setInfo.dictionary;
                                            done();
                                        }
                                    },
                                    function() {
                                        let count = set.calcCount;

                                        if (set.groups[i].items[i2].goodDictionary.main_record == 1) {
                                            let squareAmount = set.squareCount * (set.groups[i].items[i2].goodDetails.amount / 100);
                                            let perOne = set.groups[i].items[i2].goodDetails.amount_detail / set.groups[i].items[i2].goodDetails.amount;

                                            if (set.square) {
                                                count = squareAmount;
                                            }
                                            let setsCount = set.groups[i].items[i2].count / perOne;
                                            if (set.square) {
                                                setsCount = setsCount / (set.groups[i].items[i2].goodDetails.amount / 100);
                                            }
                                            // let properCount = count * perOne;

                                            // console.log(set.groups[i].items[i2].count - set.groups[i].amountAct, set.groups[i].items[i2].package, set.groups[i].items[i2].count - set.groups[i].amountAct > set.groups[i].items[i2].package)

                                            // if (setsCount > calcCount && (set.groups[i].items[i2].count / properCount) > 1 && set.groups[i].items[i2].count - properCount >= set.groups[i].items[i2].package) {
                                            if (setsCount > calcCount && set.groups[i].items[i2].count - set.groups[i].amountAct >= set.groups[i].items[i2].package) {
                                                // console.log('123', set.groups[i].items[i2].name)
                                                calcCount = Math.ceil(setsCount);
                                                if (calcCount > count) self.properCalcItem = set.groups[i].items[i2];
                                            }
                                        }

                                        if (calcCount > count) {
                                            ok = false;
                                            self.properCalc = calcCount;
                                        }

                                        i2++;
                                        if (i2 < set.groups[i].items.length) {
                                            checkItem();
                                        } else {
                                            i++;
                                            if (i < set.groups.length) {
                                                checkGroup();
                                            } else {
                                                if (ok) {
                                                    self.$modal.hide('loading');
                                                    // self.addToBasket(setId);
                                                    self.checkBeforeBasket(setId);
                                                } else {
                                                    self.$modal.hide('loading');
                                                    self.$modal.show('orderFixes2')
                                                }
                                            }
                                        }
                                    }
                                ]);
                            }

                            // ai_helper.makePost('katrisService', 'getGoodAIHelperInfoArray', {ids: ids, groupID: set.groups[i].id_good_inet}, null, function (respond) {
                            //     if (respond.status === 'OK') {
                            //         console.log(respond)
                            //         set.groups[i].infoArray = respond.data;
                                    checkItem();
                            //     }
                            // })

                        } else {
                            i++;
                            if (i < set.groups.length) {
                                checkGroup();
                            } else {
                                if (ok) {
                                    self.$modal.hide('loading');
                                    //self.addToBasket(setId);
                                    self.checkBeforeBasket(setId);
                                } else {
                                    self.$modal.hide('loading');
                                    self.$modal.show('orderFixes2')
                                }
                            }
                        }
                    }

                    let ids = [];

                    for (let i in set.groups) {
                        for (let id in set.groups[i].ids) {
                            if (!(i == 0 && id == 0)) ids += ', ';
                            ids += set.groups[i].ids[id];
                        }
                    }

                    console.log(ids)

                    ai_helper.makePost('katrisService', 'getGoodAIHelperInfoArray', {ids: ids, groupID: 0}, null, function (respond) {
                        if (respond.status === 'OK') {
                            console.log(respond)
                            set.infoArray = respond.data;
                            checkGroup();
                        }
                    })
                } else if (set.check2 && !manualSet) {
                    // self.addToBasket(setId);
                    self.checkBeforeBasket(setId);
                } else {
                    self.addToBasket(setId)
                }
            },
            fixSetComplex: function(setId, next) {
                let self = this;

                self.properCalcToBasket = false;

                let set = self.sets.find(complect => complect.id == setId);

                set.check1 = true;

                if (next == 1) {
                    self.$modal.hide('orderFixes')
                }

                set.fullfillSet()
                this.restore();

                if (next == 1) {
                    self.properCalcFull = true;
                    // self.checkBeforeBasket2(setId);
                } else {
                    self.addToBasket(setId);
                }
            },
            fixPartsCount: function(setId) {
                let self = this;

                self.$modal.hide('orderFixes2')

                let set = self.sets.find(complect => complect.id == setId);

                set.check2 = true;

                if (set.square) {
                    set.squareCount = self.properCalc;
                } else {
                    set.calcCount = self.properCalc;
                }

                self.properCalcToBasket = false;

                let tempSet = new AI_helperComplectClass(set, 0, ai_helper);

                tempSet.parts(tempSet.id, self.properCalc, 0, false, function () {
                    // console.log(tempSet)
                    // console.log(set)

                    for (let group in tempSet.groups) {
                        // console.log(tempSet.groups[group].amount, tempSet.groups[group].restAmount, tempSet.groups[group].actualAmount, tempSet.groups[group].amountAct)
                        // console.log(set.groups[group].amount, set.groups[group].restAmount, set.groups[group].actualAmount, set.groups[group].amountAct)
                        set.groups[group].amount = tempSet.groups[group].amount;
                        set.groups[group].restAmount = tempSet.groups[group].restAmount;
                        set.groups[group].actualAmount = tempSet.groups[group].actualAmount;
                        set.groups[group].amountAct = tempSet.groups[group].amountAct;
                    }

                    self.fixSetComplex(setId, 2);
                });
            },
            addToBasket: function(setId) {
                this.$modal.hide('orderFixes2')
                this.restore();
                console.log(this.properCalcToBasket)
                if (this.properCalcToBasket) {
                    let self = this;

                    let set = self.sets.find(complect => complect.id == setId);
                    set.inBusket = true;
                    ai_helper.storeComplects();

                    let allInBusket = true;
                    for (let set in ai_helper.complects) {
                        if (!ai_helper.complects[set].inBusket) allInBusket = false;
                    }

                    this.$countGlobal.number = 0;
                    this.$countGlobal.basket = 0;

                    for (let key in ai_helper.complects) {
                        if (ai_helper.complects[key] != 'empty') {
                            if (ai_helper.complects[key].id != 0) {
                                if (ai_helper.complects[key].inBusket)
                                    this.$countGlobal.basket++;
                                else
                                    this.$countGlobal.number++;
                            } else {
                                this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length;
                            }
                        }
                    }

                    this.count = this.$countGlobal;

                    self.$added.state = true;
                    setTimeout(function () {
                        self.$added.state = false;
                    }, 2500);

                    if (allInBusket) self.$router.push({path: '/accessoriesOrdering'});

                    ai_helper.check_complect();
                    self.updateTotal();
                }
            },
            setActiveThumb: function(item) {
                let self = this;

                if (self.activeThumbID != item.id) {
                    self.activeThumbID = item.id
                } else {
                    self.activeThumbID = 0;
                }
            },
            closeFlag: function() {
                this.activeThumbID = 0;
            },
            openVideo: function(link) {
                this.activeVideoLink = link.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
                this.$modal.show('video')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },
        beforeRouteLeave(to, from, next) {
            if (to.matched[0].path == '/itemsList/:setId/:groupId') {
                let posTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                window.localStorage.setItem('position', posTop);
                next();
            } else {
                next();
            }
        },
    }
</script>

<style scoped>
    .tableHeader {
        /*font-size: 12px;*/
        line-height: 1.2;

        font-size: 17px;
        font-weight: 600;
        text-align: center;
        /*padding: 10px 0;*/
        padding-bottom: 20px;
        position: relative;

        background: #fff;

        border-bottom: 1px solid #dee2e6;
    }
    .tableHeader td {
        padding: 3px 0.5rem;
        padding-top: 10px;
        border-top: 1px solid #007bff;
    }

    .setItems {
        border-top: 1px solid #98cfff;
    }

    .setItems .table:first-of-type {
        margin-bottom: 30px;
    }

    .card div img {
        /*position: absolute;*/
        /*bottom: 10px;*/
        /*right: 10px;*/
        /*width: 50px;*/
        width: 90%;
    }

    .addMore {
        position: absolute;
        z-index: 20;
        background-color: white;
        border: 1px solid #dee2e6;
        width: 400px;
        -webkit-box-shadow: 2px 3px 6px 0px #6767674d;
        box-shadow: 2px 3px 6px 0px #6767674d;
        right: 175px;
        top: 62px;
        border-radius: 5px;
        padding: 6px 0;
    }
    .addMore li {
        font-size: 16px;
        padding: 6px;
    }

    .addMoreList {
        font-size: 14px;
        margin: 0 15px;
        margin-bottom: 43px;
        border-bottom: 1px solid #dee2e6;
        padding-bottom: 23px;
        width: 100%;
    }

    .addMoreList li {
        padding: 5px 0;
    }

    .card-img-top {
        /*height: 150px;*/
        height: 80px;
        margin-top: 10px;
        text-align: center;
    }
    .card-body {
        font-size: 13px;
        padding: 10px 18px;
        /*min-height: 83px;*/
        min-height: 105px;
        /*word-break: break-all;*/
    }

    .addMoreSlider {
        flex: 0 0 94%;
        margin-left: 32px;
    }

    .nextSlide {
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 1;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
        align-items: center;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
        justify-content: center;
        width: 15%;
        color: #000;
        text-align: center;
        opacity: 0.5;
        -webkit-transition: opacity 0.15s ease;
        transition: opacity 0.15s ease;

        right: -83px;
        font-size: 36px;
    }

    .buyMoreContainer {
        /*background-color: #27a0f9;*/
        background-color: #007bff;
        padding: 0 10px;
        padding-bottom: 10px;
        border-radius: 10px;
        margin-top: 20px;
    }

    .buyMoreContainer h3 {
        color: #fff;
        font-weight: 400 !important;
        margin-bottom: 0;
    }

    .buyMore {
        /*background-color: #f0f8ffa3 !important;*/
        background-color: #fff !important;
        /*border-bottom: 1px solid #dee2e6;*/
        border-radius: 10px;
    }

    .buyMore .tableHeader td {
        border-top: none;
    }

    .tableHeader td {
        font-weight: 600;
        text-align: center;
        /*padding: 27px 0;*/
        padding-top: 10px;
        padding-bottom: 30px;
        position: relative;
    }

    .tableHeader td:after {
        content: '';
        height: 30px;
        width: 1px;
        background: #adadad;
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);
    }

    .tableHeader td:nth-last-of-type(1):after {
        background: #fff;
    }

    .tableHeader td i {
        position: absolute;
        bottom: 5px;
        left: calc(50% - 8px);
    }

    .buyMore .tableAmount {
        width: auto;
    }

    .item td {
        position: relative;
    }
    .item td:after {
        content: '';
        height: 30px;
        width: 1px;
        background: #adadad;
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);

    }

    .item td.noAfter:after {
        background: #fff;
    }

    .setItems table:nth-of-type(odd) {
        background-color: rgba(233, 236, 239, 0.33);
    }

    .totalTable {
        background-color: #fff !important;
    }

    .group {
        margin-bottom: 30px;
        border-bottom: 1px solid #dee2e6;
    }

    .titleWide {
        max-width: 500px;
    }

    .minimize {
        position: absolute;
        top: calc(50% - 22px);
    }

    .saleButton {
        font-size: 15px;
    }

    #navbarCollapse {
        font-size: 14px;
    }

    @-moz-document url-prefix() {
        /*.tableHeader {*/
            /*border-bottom: 2px solid #dee2e6 !important;*/
        /*}*/
        /*.table tbody + tbody {*/
            /*border-top: 2px solid #dee2e6 !important;*/
            /*background: transparent;*/
        /*}*/
        /*.group {*/
            /*border-bottom: 2px solid #dee2e6 !important;*/
        /*}*/
        /*.item {*/
            /*background: transparent !important;*/
        /*}*/

        .tableHeader td {
            border-bottom: 1px solid #dee2e6;
        }
    }

    /*.thumb {*/
    /*    position: absolute;*/
    /*    right: 8px;*/
    /*    top: 21px;*/
    /*    font-size: 30px;*/
    /*    cursor: pointer;*/
    /*    color: #006ce0;*/
    /*}*/

    .thumb {
        position: absolute;
        right: 2px;
        top: 0px;
        font-size: 24px;
        cursor: pointer;
        color: #006ce0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        resize: vertical;
    }

    .nameSpan {
        width: 90%;
        display: inline-block;
    }

    .added {
        background-color: #ffffbc;
    }
</style>
